(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("notFound", {
        templateUrl: "app/security/notFound.component.html",
        controller: ["statusCodeService", NotFoundCtrl],
        controllerAs: "vm"
    });
    function NotFoundCtrl(statusCodeService) {
        statusCodeService.setStatusCode("404");
    }
}());
